module.exports = __webpack_public_path__ + "media/images/home-banners/johannes-plenio-629984-unsplash-a0be598d490fc83de366913438c785c2.jpg";